import React, { Component } from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton
} from 'react-share'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import TrackingHOC from '../../hocs/TrackingHOC'
import styled from 'styled-components'
import { CopyUrl } from '../'
import 'w3-css/w3.css'
import messages from './messages'
import { SVGIcon } from '..'
import { getVersionIcon } from '../../helpers/utils'
import { NAV_MODULE_ICON } from '../../constants'

const Wrapper = styled.div`
  display: flex;
  padding-right: 15px;

  .SocialMediaShareButton {
    height: var(--share-button-px);
    width: var(--share-button-px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 7px;
  }

  svg {
    fill: var(--clr-grey-6-to-black);
  }

  svg:hover {
    fill: var(--clr-grey-3-to-white);
    }
`

const Share = styled.p`
  color: var(--clr-grey-4-to-text);
  font-size: 18px;
  padding: 3px 10px 0px 0px;
`

const Styledbutton = styled.button`
  border: none;
  background: none;
  padding: 0px;
  width: var(--share-button-px);
  svg {
    fill: var(--clr-accent-to-black);
  }
`

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 40px;
`
class SocialMedia extends Component {
  socialMediaTracking = () => {
    const { contentId, contentType, contentTitle, createEvent } = this.props

    createEvent({
      category: 'socialMedia',
      data: {
        content_type: contentType,
        content_id: contentId,
        content_title: contentTitle
      }
    })
  }

  render() {
    const { buttonToggle, showButtons, language, facebook, twitter, mail, version } = this.props
    const url = window.location.href
    let translated = messages[language]

    return (
      <Container>
        <If condition={showButtons}>
          <Wrapper className="w3-animate-right">
            <Styledbutton aria-label="Share button" onClick={buttonToggle}>
              <SVGIcon
                src={getVersionIcon(NAV_MODULE_ICON.share, version)}
              />
            </Styledbutton>
            {facebook &&
              <FacebookShareButton
                aria-label="Facebook"
                onShareWindowClose={this.socialMediaTracking}
                url={url}
              >
                <SVGIcon
                  src={getVersionIcon(NAV_MODULE_ICON.fb, version)}
                />
              </FacebookShareButton>
            }
            {twitter &&
              <TwitterShareButton
                aria-label="Twitter"
                onShareWindowClose={this.socialMediaTracking}
                url={url}
              >
                <SVGIcon
                  src={getVersionIcon(NAV_MODULE_ICON.twitter, version)}
                />
              </TwitterShareButton>
            }
            {mail &&
              <EmailShareButton
                aria-label="Email"
                onShareWindowClose={this.socialMediaTracking}
                url={url}
              >
                <SVGIcon
                  src={getVersionIcon(NAV_MODULE_ICON.mail, version)}
                />
              </EmailShareButton>
            }
            <CopyUrl aria-label="Copy URL" translated={translated} version={version}/>
          </Wrapper>
        </If>
        <If condition={!showButtons}>
          <Wrapper className="w3-animate-opacity" style={{ paddingRight: 20 }}>
            <Share className="share_title">{translated['share']}</Share>
            <Styledbutton aria-label="Share button" onClick={buttonToggle}>
              <SVGIcon
                src={getVersionIcon(NAV_MODULE_ICON.share, version)}
              />
            </Styledbutton>
          </Wrapper>
        </If>
      </Container>
    )
  }
}

export default LanguageProvider(TrackingHOC(SocialMedia))



// WEBPACK FOOTER //
// ./src/components/SocialMedia/index.js